import { StatusEnum } from '@/rtkApi/mddApiSliceGeneratedV2'

export const ODCS_STATUS_VALUES: StatusEnum[] = [
	'draft',
	'under',
	'review',
	'published',
	'retired',
]

export const ODCS_STATUS_I18N_KEYS: Record<StatusEnum, string> = {
	draft: 'ODCS_STATUS_DRAFT',
	under: 'ODCS_STATUS_UNDER',
	review: 'ODCS_STATUS_REVIEW',
	published: 'ODCS_STATUS_PUBLISHED',
	retired: 'ODCS_STATUS_RETIRED',
}

export const DEFAULT_ODCS_STATUS: StatusEnum = 'draft'
